import {
  createApiResource,
  ResourceId,
  DeleteResource,
  PatchResource,
  CreateResource,
  UnpagedListResource,
  ListResource
} from './apiResourceFactory';

import { Contact, ContactDTO, Note, NoteCreateDTO } from './apiTypes.shim';

import type { AxiosInstance } from 'axios';

export interface NoteChildResource extends CreateResource<NoteCreateDTO, Note>, ListResource<Note> {}

export interface ApiResourceWithNotes {
  notes: (parentId: ResourceId) => NoteChildResource;
}

export function createNotesResource(apiClient: AxiosInstance, parentResourceUri: string): NoteChildResource {
  return createApiResource(apiClient, `${parentResourceUri}/notes`);
}

export interface ContactChildResource
  extends UnpagedListResource<Contact>,
    CreateResource<ContactDTO, Contact>,
    PatchResource<Contact, Contact>,
    DeleteResource {}

export interface ApiResourceWithContacts {
  contacts: (parentId: ResourceId) => ContactChildResource;
}

export function createContactsResource(apiClient: AxiosInstance, parentResourceUri: string): ContactChildResource {
  return createApiResource(apiClient, `${parentResourceUri}/contacts`);
}
